import axiosHttp from './axiosHttp'

export default {
  async getAppConfig() {
    try {
      const res = await axiosHttp.get('/auth/app-config')
      return res?.data || null
    } catch (error) {
      return null
    }
  }
}

